// CONSTANTS are all caps.
const NS = 'SearchResultsPage';
const CLS = 'searchResultsPage';
const PG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadPg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import validate from 'validate.js';
import * as utils from '../../../../global/js/utils';

export class SearchResultsPage {
	constructor($el) {
		// $el is the page node return by the loadSearchResultsPage function
		this.$el = $el;
	}

	init() {
		this.setSearchResultsPage();
		this.initFormValidationConstraints();
	}

	setSearchResultsPage() {
		// Add Some logic here
	}

	initFormValidationConstraints() {
		// the page has only one form
		const This = this;
		let $form = $(this.$el).find('form')[0];
		utils.formValidation($form, This);
	}

	formSuccessCallback(form) {
		// check if (same as billing) checkbox is ticked
		$(form).submit();
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/pages/searchResultsPage/js/searchResultsPage.js